// Part of the agent UI for spark#246 / @adr SPARK-0034-ai-agents-are-project-context-not-team-members@1: an AI agent is PROJECT CONTEXT, never a team
// member. Nothing here reaches the solver, and no agent carries a Powers profile — Powers is a
// psychometric instrument built for humans, and putting agents on that scale would argue they are
// interchangeable with candidates, which is the model @adr SPARK-0034-ai-agents-are-project-context-not-team-members@1 rejects.

export function AgentMonogram({ name }: { name: string }) {
  const initials = name
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
  return (
    <span
      className="flex h-10 w-10 shrink-0 items-center justify-center font-serif text-sm"
      style={{ background: "var(--color-accent)", color: "var(--color-on-accent)" }}
      aria-hidden
    >
      {initials}
    </span>
  );
}
